import {type DocumentNode, gql} from '@apollo/client';
import {type Filter, GqlRequestBuilder} from '@igp/shared/api';
import type {QueryGetKeycloakLogsArgs, ResourceType} from '@igp/shared/contract/pam';

import type {KeycloakLogEntityType, KeycloakLogFilterKeys, KeycloakLogQueryFields} from './types';

export class KeycloakLogRequestBuilder extends GqlRequestBuilder<
    KeycloakLogEntityType,
    QueryGetKeycloakLogsArgs,
    KeycloakLogQueryFields,
    KeycloakLogFilterKeys
> {
    protected validateFilters(_filter: Partial<Record<KeycloakLogFilterKeys, unknown>>): void {
        return;
    }

    protected buildQuery(fields: KeycloakLogQueryFields[]): DocumentNode {
        const requiredFields: KeycloakLogQueryFields[] = ['log_id'];
        const queryFields: KeycloakLogQueryFields[] = [...new Set([...fields, ...requiredFields])];
        return gql`
            query GetKeycloakLogs($filter: KeycloakLogsFilter, $start: Int, $end: Int) {
                getKeycloakLogs(filter: $filter, start: $start, end: $end) {
                    items {
                        ${this.buildQueryFields(queryFields)}
                    }
                }
            }
        `;
    }

    protected buildFilter(filter: Filter<KeycloakLogFilterKeys>): Pick<QueryGetKeycloakLogsArgs, 'filter'> {
        return {
            filter: {
                operator_uuid: this.toStringFilter(filter, 'operator_uuid'),
                target_user_uuid: this.toStringFilter(filter, 'target_user_uuid'),
                date: this.toGQLDateRange(
                    this.getLatestTimestamp(filter['date.from'] as number, filter['date.min'] as number),
                    filter['date.to']
                ),
                operation_type: this.toGQLMultiselectFilter(filter, 'operation_type'),
                resource_type:
                    this.toGQLMultiselectFilter<ResourceType[]>(filter, 'resource_type') ??
                    this.toGQLMultiselectFilter<ResourceType[]>(filter, 'default_resource_type'),
            },
        };
    }
}
